import type { SVGProps } from 'react'
const SvgSyDownload = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path d="M12.123 2.645a.75.75 0 0 0-.75.75v12.04a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V3.396a.75.75 0 0 0-.75-.75" />
			<path d="M9.207 11.758a.75.75 0 0 0-.53.219.75.75 0 0 0-.003 1.06l2.916 2.928a.75.75 0 0 0 1.064 0l2.916-2.928a.75.75 0 0 0-.002-1.06.75.75 0 0 0-1.062.002L12.12 14.37l-2.382-2.39a.75.75 0 0 0-.531-.221" />
			<path
				d="M6.547 7.379a4.437 4.437 0 0 0-4.426 4.424v4.885a4.446 4.446 0 0 0 4.436 4.433h11.14a4.434 4.434 0 0 0 4.424-4.424v-4.884a4.444 4.444 0 0 0-4.433-4.434h-.932a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.932a2.92 2.92 0 0 1 2.933 2.934v4.884a2.91 2.91 0 0 1-2.924 2.924H6.557a2.923 2.923 0 0 1-2.936-2.933v-4.885a2.914 2.914 0 0 1 2.926-2.924h.941a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyDownload
